const editorSelector = 'input, select, textarea, [contenteditable]';
/**
 * 聚焦到一个输入框组件上，如果需要，会滚动过去
 *
 * @param x Vue, Element
 */
export function focusEditor(x) {
  if (!x) return;
  let el = x;
  if (el && '$el' in el) {
    el = el.$el;
  }
  if (el && !el.matches(editorSelector)) {
    var _el$querySelector, _el;
    el = (_el$querySelector = (_el = el).querySelector) === null || _el$querySelector === void 0 ? void 0 : _el$querySelector.call(_el, editorSelector);
  }
  if (el && 'focus' in el) {
    var _el$scrollIntoViewIfN, _el2;
    el.focus();
    (_el$scrollIntoViewIfN = (_el2 = el).scrollIntoViewIfNeeded) === null || _el$scrollIntoViewIfN === void 0 || _el$scrollIntoViewIfN.call(_el2);
  }
  return el;
}
//# sourceMappingURL=focusEditor.js.map
